import { variables } from "../../variables";
export default {
    actions: {
        async _setPartnerRecommendations(context, { partnerRecommendations }){
            return await context.rootGetters.api.post(`${variables.serverUrl}/api/v1/clubs/config-partner-recommendations?number=${partnerRecommendations}`);
        },
        async _setCommitteeVotes(context, { committeeVotes }){
            return await context.rootGetters.api.post(`${variables.serverUrl}/api/v1/clubs/config-committee-votes?votes=${committeeVotes}`);
        },
        async _getPartnerRecommendations(context){
            return await context.rootGetters.api.get(`${variables.serverUrl}/api/v1/clubs/partner-recommendations-number`);
        },
        async _getCommitteeVotes(context){
            return await context.rootGetters.api.get(`${variables.serverUrl}/api/v1/clubs/committee-votes`);
        },
    }
}